import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

const Project3Card = () => {
    return (
        <Container>
            <Row>
                <Col lg={10} className='mx-auto'>
                    <p className='lead'>
                        Having relied on GitHub, Jira, and Slack to coordinate development work, I wanted a
                        lighter-weight way for teams to plan technical projects visually. Co-Design let users
                        collaboratively "storyboard" a project, then post individual sections to a built-in
                        marketplace where freelancers could bid to complete them.
                    </p>

                    <h3 className='text-uppercase mt-4 fs-6 fw-bold'>What I Built</h3>
                    <ul>
                        <li>A visual storyboarding interface for mapping project requirements, tasks, and dependencies in real time.</li>
                        <li>A marketplace layer where users posted individual project sections and freelancers submitted competing bids.</li>
                        <li>Payment processing to handle secure transactions once a freelancer's work was accepted.</li>
                    </ul>

                    <h3 className='text-uppercase mt-4 fs-6 fw-bold'>Outcome</h3>
                    <p>
                        The result was a single tool that combined project planning with task outsourcing, giving
                        small teams a lighter alternative to running separate planning and freelancing tools side by
                        side.
                    </p>

                    <p className='text-muted mb-0'><i>Completed August 2021</i></p>
                </Col>
            </Row>
        </Container>
    )
}

export default Project3Card;
